import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const Sales = (props: LevelProps) => {
  return <LevelPage {...props} imgScale={0.45} cards={LEVEL_CARDS.L3.SALES} />
}
